<template lang="jade">

</template>

<script>
export default {
  data: () => ({}),
  props: {
    content: {
      type: Object
    }
  }
}
</script>



// WEBPACK FOOTER //
// footer.vue?fefb0ff0